import { render } from "./CreditsPayment.vue?vue&type=template&id=2d66937e&scoped=true"
import script from "./CreditsPayment.vue?vue&type=script&lang=js"
export * from "./CreditsPayment.vue?vue&type=script&lang=js"

import "./CreditsPayment.vue?vue&type=style&index=0&id=2d66937e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d66937e"]])

export default __exports__